import React, { Component } from 'react';
import { compose } from 'redux';
import CloakLoading from '../../../../components/CloakLoading';
import Translations from '../../../../containers/Translations';
import { codes } from '../../../../data/translations';
import { Toggleable } from '../../../../utils/decorators';
import { getInitialCheckSmsPincodeData, postInitialCheckSmsPincodeData } from '../../api';
import { actionTypeEnum } from '../../consts';
import AuthenticationDescription from '../AuthenticationDescription';
import AuthenticationErrorsBox from '../AuthenticationErrorsBox';
import AuthenticationTitle from '../AuthenticationTitle';
import { AuthenticationCheckSMSPinCodeForm } from './AuthenticationCheckSMSPinCodeForm';
import classes from './styles/index.module.scss';

class AuthenticationCheckSMSPinCodeComponent extends Component {
	state = {
		mobile: '',
		canResendSms: null,
		resendAvailableAt: null,
		errors: {},
		countDownIntervalId: null,
	};

	componentDidMount() {
		this.handleSendPinCode();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.canResendSms !== prevState.canResendSms && this.state.canResendSms === false) {
			this.initCountDown();
		}
	}

	componentWillUnmount() {
		clearInterval(this.state.countDownIntervalId);
	}

	get formattedCountdownTime() {
		let minutes = Math.floor(this.state.resendAvailableAt / 60);
		let seconds = Math.floor(this.state.resendAvailableAt % 60);

		if (minutes < 10) {
			minutes = `0${minutes}`;
		}

		if (seconds < 10) {
			seconds = `0${seconds}`;
		}

		return `${minutes}:${seconds}`;
	}

	initCountDown = () => {
		if (this.state.resendAvailableAt) {
			const countDownIntervalId = setInterval(() => {
				this.setState({
					resendAvailableAt: this.state.resendAvailableAt - 1,
				});
				if (this.state.resendAvailableAt <= 0) {
					clearInterval(countDownIntervalId);
					this.setState({
						canResendSms: true,
						resendAvailableAt: 0,
					});
				}
			}, 1000);
			this.setState({
				countDownIntervalId,
			});
		}
	};

	handleSendPinCode = (isResend) => {
		this.props.toggleProp('isPending', true);
		getInitialCheckSmsPincodeData({ isResend })
			.then(this.handleInitialCheckSmsPincodeDataSuccess)
			.catch(this.handleInitialCheckSmsPincodeDataError);
	};

	handleInitialCheckSmsPincodeDataSuccess = ({ data }) => {
		this.props.toggleProp('isRegisterPasswordInitialized', true);
		this.setState({
			mobile: data.mobile,
			canResendSms: data.canResendSms,
			resendAvailableAt: data.resendAvailableAt,
		});
		this.props.toggleProp('isPending', false);
	};

	handleInitialCheckSmsPincodeDataError = ({ response: { data } }) => {
		this.props.toggleProp('isPending', false);

		if (data.errors) {
			if (data.errors._.sessionExpired) {
				this.props.authenticationSetActionType(actionTypeEnum.SESSION_EXPIRED);
				return;
			}
			if (data.errors._.cannotSendSms) {
				this.props.authenticationSetActionType(actionTypeEnum.CAN_NOT_SEND_SMS);
				return;
			}
		}

		this.props.authenticationSetActionType(actionTypeEnum.SORRY_AN_ERROR_OCCURRED);
	};

	handleRegisterPasswordFormSubmit = (values) => {
		this.props.toggleProp('isPending', true);
		return postInitialCheckSmsPincodeData(values)
			.then(this.handleRegisterPasswordFormSubmitSuccess)
			.catch(this.handleRegisterPasswordFormSubmitError);
	};

	handleRegisterPasswordFormSubmitSuccess = ({ data }) => {
		this.props.toggleProp('isSubmitted', true);
		this.props.toggleProp('isPending', false);
		this.props.authenticationSetActionType(data.action);
	};

	handleRegisterPasswordFormSubmitError = ({
		response: {
			data: { errors },
		},
	}) => {
		if (errors._.sessionExpired) {
			this.props.authenticationSetActionType(actionTypeEnum.SESSION_EXPIRED);
			return;
		}
		if (errors._.checkSmsPinCodeAttemptsExceeded) {
			this.props.authenticationSetActionType(actionTypeEnum.PIN_CODE_ATTEMPTS_EXCEEDED);
			return;
		}
		if (errors._) {
			this.setState({
				errors: errors._,
			});
			this.props.toggleProp('isPending', false);
			return;
		}
		this.props.authenticationSetActionType(actionTypeEnum.SORRY_AN_ERROR_OCCURRED);
		this.props.toggleProp('isPending', false);
	};

	render() {
		const { translate, isPending, isRegisterPasswordInitialized, actionType } = this.props;

		const is2FA = actionTypeEnum.CHECK_SMS_PIN_CODE_2FA === actionType;
		const is2FASetup = actionTypeEnum.CHECK_SMS_PIN_CODE_2FA_SETUP === actionType;

		return (
			<>
				{(isPending || !isRegisterPasswordInitialized) && <CloakLoading />}
				{isRegisterPasswordInitialized && (
					<>
						<AuthenticationTitle>
							{is2FA || is2FASetup
								? translate(codes.user.twoStepAuthentication)
								: translate(codes.user.registerPassword)}
						</AuthenticationTitle>
						{is2FASetup && (
							<AuthenticationDescription>
								{translate(codes.user.toSecureYourAccountDescription)}
							</AuthenticationDescription>
						)}
						{Object.keys(this.state.errors).length > 0 && (
							<AuthenticationErrorsBox errors={this.state.errors} />
						)}
						<span className={classes.oneTimePinCode}>{translate(codes.user.oneTimePinCode)}</span>
						<AuthenticationDescription>
							{translate(codes.user.pleaseCheckYourMobilePin, [this.state.mobile])}
						</AuthenticationDescription>
						<AuthenticationCheckSMSPinCodeForm
							{...this.state}
							onSubmit={this.handleRegisterPasswordFormSubmit}
							handleResendPinCode={() => {
								this.handleSendPinCode(true);
							}}
							translate={translate}
							formattedTime={this.formattedCountdownTime}
							is2FA={is2FA}
						/>
					</>
				)}
			</>
		);
	}
}

export const AuthenticationCheckSMSPinCode = compose(
	Translations,
	Toggleable({
		isRegisterPasswordInitialized: false,
		isPending: false,
	}),
)(AuthenticationCheckSMSPinCodeComponent);
